<template>
  <div 
    :id="id + '___FB_dropdown_outer_'" 
    class="custom-dropdown dropdown b-dropdown" 
    :class="{
      'btn-group': !block,
      'dropup': dropup,
      'show': showMenu,
    }"
    @focusout="handleFocusOut"
    @blur="handleBlur"
  >
    <button 
      class="btn dropdown-toggle" 
      :class="[
        toggleClass, 
        'btn-' + variant, 
        {
          'dropdown-toggle-no-caret': noCaret,
          'btn-block': block,
        },
      ]" 
      :disabled="disabled" 
      @click="handleToggle">
      <slot name="button-content" />
    </button>
    <ul 
      ref="menu" 
      role="menu"
      class="dropdown-menu tw-z-50"
      :class="[
        menuClass, 
        showMenuStyle, 
        'dropdown-menu-' + variant, 
        {
          'dropdown-menu-left': !right,
          'dropdown-menu-right': right,
          'tw-absolute': right,
          'show': showMenu,
        },
      ]" 
      @click="handleHideMenu">
      <slot />
    </ul>
  </div>
</template>

<script>
  import { 
    EVENT_DROPDOWN_SHOW, 
    EVENT_DROPDOWN_HIDE,
  } from '../plugins/Dropdown/constants'
  import {
    windowsComputed,
  } from '@state/helpers'

  export default {
    name: 'FabricDropdown',
    props: {
      id: {
        type: [String],
        default: () => { return '' + Math.floor(Math.random() * Date.now())},
      },
      variant: {
        type: String,
        default: 'secondary',
      },
      toggleClass: {
        type: String,
        default: '',
      },
      menuClass: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      noCaret: {
        type: Boolean,
        default: false,
      },
      block: {
        type: Boolean,
        default: false,
      },
      dropup: {
        type: Boolean,
        default: false,
      },
      right: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        EVENT_DROPDOWN_SHOW,
        EVENT_DROPDOWN_HIDE,
        showMenu: false,
        touchStart: {},
        touchCurrent: {},
      }
    },
    computed: {
      ...windowsComputed,
      showMenuStyle() {
        return this.showMenu ? 'tw-inline-flex tw-flex-col' : 'tw-hidden'
      },
    },
    mounted() {
      this.$root.$on(EVENT_DROPDOWN_SHOW, dataEvent => {
        const { id } = dataEvent
        if (id === this.id) {
          this.handleShowMenu()
        } else {
          this.handleHideMenu()
        }
      })

      this.$root.$on(EVENT_DROPDOWN_HIDE, dataEvent => {
        const { id } = dataEvent
        if (id === this.id) {
          this.handleHideMenu()
        }
      })
    },
    methods: {
      handleToggle(event) {
        event.preventDefault()
        if (this.showMenu) {
          this.handleHideMenu()
        } else {
          this.handleShowMenu()
        }
      },
      handleBlur(event){
        if (this.isTablet){
          this.handleFocusOut()
        }
      },
      handleFocusOut(event){
        setTimeout(() => {
          if (this.showMenu){
            this.handleHideMenu()
          }
        }, 100);
      },
      handleHideMenu() {   
        this.$emit('hide')
        this.showMenu = false   
        this.$nextTick(() => {
          this.$emit('hidden', this.id)
        });
        document.removeEventListener("mousedown", this.mouseDownCallback, false);
        if (this.isTablet){
          document.removeEventListener("touchstart", this.touchStartCallback, false);
          document.removeEventListener("touchmove", this.touchMoveCallback, false);
          document.removeEventListener("touchend", this.touchEndCallback, false);
        }
      },
      handleShowMenu() {
        this.$emit('show')
        this.showMenu = true
        this.$nextTick(() => {
          this.$emit('shown', this.id)
          if (this.isTablet){
            document.addEventListener("touchstart", this.touchStartCallback, false);
            document.addEventListener("touchmove", this.touchMoveCallback, false);
            document.addEventListener("touchend", this.touchEndCallback, false);
          }else{
            document.addEventListener("mousedown", this.mouseDownCallback, false);
          }
        });
      },
      mouseDownCallback(event) {
        if (!this.$refs.menu) {
          return
        }
        const menuBoundingRect = this.$refs.menu.getBoundingClientRect()
        const isClickWithinMenu = event.clientX >= menuBoundingRect.x &&
          event.clientY >= menuBoundingRect.y &&
          event.clientX <= (menuBoundingRect.x + menuBoundingRect.width) &&
          event.clientY <= (menuBoundingRect.y + menuBoundingRect.height)
        if (!isClickWithinMenu) {
          this.handleHideMenu()
        }
      },
      touchStartCallback(event){      
        this.touchStart = {
          x: event.targetTouches[0].clientX,
          y: event.targetTouches[0].clientY,
        }
        this.touchCurrent = {
          x: event.targetTouches[0].clientX,
          y: event.targetTouches[0].clientY,
        }
      },
      touchMoveCallback(event){
        this.touchCurrent = {
          x: event.targetTouches[0].clientX,
          y: event.targetTouches[0].clientY,
        }
      },
      touchEndCallback(event){
        const myId = `${this.id}___FB_dropdown_outer_`

        const touchDeltaX = Math.abs(this.touchStart.x - this.touchCurrent.x)
        const touchDeltaY = Math.abs(this.touchStart.y - this.touchCurrent.y)

        if(touchDeltaX <= 15 || touchDeltaY <= 15 ){
          // console.log('Minimal Movement: assume click')
          let internalClick = false
          if (event.path){
            event.path.forEach((item) => {
              if (item.id === myId){
                internalClick = true
              }
            });
          }

          if (!internalClick && this.isIos){
            this.handleFocusOut()
          }

        }else{
        // console.log('Detected Movement: assume drag / pan')
        }

        this.touchStart = {}
        this.touchCurrent = {}
      },
    },
  }
</script>
